export default function getPanelDataItems() {
  const panelToken = sessionStorage.getItem("lfcPanelToken");
  const panelSessionId = sessionStorage.getItem("lfcPanelSessionId");
  const panelConfigString = sessionStorage.getItem("lfcPanelConfigString");

  if (panelSessionId) {
    return { panelToken, panelSessionId, panelConfigString };
  }

  return null;
}
